import Slider from 'react-slick';
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { NextArrow, PrevArrow } from "../Arrows";
import CustomButton from '../CustomButton';

const extractImageFromDescription = (description) => {
  if (!description) return null;

  const imgMatch = description.match(/<img[^>]+src="([^"]+)"/);
  return imgMatch ? imgMatch[1] : null;
};

const BlogCard = ({ blog, imageUrl, wrapperClass = "" }) => {
  return (
    <div className={wrapperClass}>
      <div className="blog-image">
        <img
          src={imageUrl}
          style={{ width: "100%" }}
          className="img-fluid"
          alt="blog"
        />
      </div>
      <div className="date-wrap">
        <div className="date">
          {new Date(blog.pubDate).toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
        </div>
      </div>
      <div className="blog-content">
        {/* <div className="blog-meta">
            <span>{blog.category_title}</span>
            &nbsp;<span>/</span>&nbsp;
            <div className="designation">
              <h5>{blog.author_name}</h5>
            </div>
         </div> */}
        <h4>
          <a href={blog.link} target="_blank" rel="noreferrer noopener">
            {blog.title}
          </a>
        </h4>
      </div>
    </div>
  );
};

function Blog({ blog, blogs }) {
  const location = useLocation();
  const isBlogPage = location.pathname === "/blogs";

  const [ReadMore, setReadMore] = useState(12);

  const handleLoadMore = () => {
    setReadMore((prev) => prev + 6);
  };

  const blogSlider = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    arrows: true,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    draggable: false,
    swipe: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <>
      <div className="blog-grid-section mb-100" id="blog-grid">
        <div className="container">
          <div className="section-title2 primary3 text-start" data-aos="fade-up">
            <span>{blog.main_title}</span>
            <h2>{blog.highlist_title}</h2>
          </div>
          {isBlogPage ? (
            <>
              <div className="position-relative g-4 blog-items-wrap blog-grid" data-aos="fade-up">
                <div className='row'>
                  {blogs?.slice(0, ReadMore).map((b) => {
                    const imageUrl = extractImageFromDescription(b.description) || b.image;
                    return (

                      <div className="single-blog-1 style-2 blog-items col-lg-4 col-md-6 col-sm-6 col-12" key={b.guid} >
                        <BlogCard
                          blog={b}
                          imageUrl={imageUrl}
                          wrapperClass="glass-effect"
                        />
                      </div>
                    )
                  })
                  }
                </div>

                {blogs?.length > ReadMore && (
                  <div className="text-center mt-4">
                    <button className="btn--primary2" onClick={handleLoadMore} >
                      Read More <CustomButton />
                    </button>
                  </div>
                )}

              </div>
            </>
          ) : (
            <>
              <div className="row position-relative g-4 blog-items-wrap" data-aos="fade-up">
                <Slider {...blogSlider}>
                  {
                    blogs?.map(b => {
                      const imageUrl = extractImageFromDescription(b.description) || b.image;
                      return (

                        <div key={b.guid}>
                          <BlogCard
                            blog={b}
                            imageUrl={imageUrl}
                            wrapperClass="single-blog-1 style-2 glass-effect blog-items"
                          />
                        </div>
                      )
                    })
                  }
                </Slider>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Blog;